import { ServiceType, ServiceTypeStr } from '@common/enums';

type Value = {
  displayName: string;
  serviceType: ServiceType;
};

export const ServiceTypeMetadataMap: Record<ServiceTypeStr, Value> = {
  [ServiceTypeStr.Mail]: {
    serviceType: ServiceType.Mail,
    displayName: 'Mail'
  },
  [ServiceTypeStr.Drive]: {
    serviceType: ServiceType.Drive,
    displayName: 'Drive'
  },
  [ServiceTypeStr.Contacts]: {
    serviceType: ServiceType.Contacts,
    displayName: 'Contacts'
  },
  [ServiceTypeStr.Calendar]: {
    serviceType: ServiceType.Calendar,
    displayName: 'Calendar'
  },
  [ServiceTypeStr.SharePoint]: {
    serviceType: ServiceType.SharePoint,
    displayName: 'SharePoint'
  },
  [ServiceTypeStr.TeamDrives]: {
    serviceType: ServiceType.TeamDrives,
    displayName: 'Shared drives'
  },
  [ServiceTypeStr.Users]: {
    serviceType: ServiceType.Users,
    displayName: 'Users'
  },
  [ServiceTypeStr.PublicFolder]: {
    serviceType: ServiceType.PublicFolder,
    displayName: 'Public folder'
  },
  [ServiceTypeStr.Export]: {
    serviceType: ServiceType.Export,
    displayName: 'Export results'
  },
  [ServiceTypeStr.PersonalSite]: {
    serviceType: ServiceType.PersonalSite,
    displayName: 'Personal site'
  },
  [ServiceTypeStr.PublicFolderMail]: {
    serviceType: ServiceType.PublicFolderMail,
    displayName: 'Public folder mail'
  },
  [ServiceTypeStr.PublicFolderCalendar]: {
    serviceType: ServiceType.PublicFolderCalendar,
    displayName: 'Public folder calendar'
  },
  [ServiceTypeStr.PublicFolderContact]: {
    serviceType: ServiceType.PublicFolderContact,
    displayName: 'Public folder contact'
  },
  [ServiceTypeStr.Teams]: {
    serviceType: ServiceType.Teams,
    displayName: 'Teams'
  },
  [ServiceTypeStr.CalculateProviderSize]: {
    serviceType: ServiceType.CalculateProviderSize,
    displayName: 'Calculate provider size'
  },
  [ServiceTypeStr.Payments]: {
    serviceType: ServiceType.Payments,
    displayName: 'Payments'
  },
  [ServiceTypeStr.History]: {
    serviceType: ServiceType.History,
    displayName: 'History'
  },
  [ServiceTypeStr.All]: {
    serviceType: ServiceType.All,
    displayName: 'All'
  }
};
